import { useEffect } from 'react'
import ReactGoogleLogin, {
  GoogleLoginResponse,
  GoogleLoginResponseOffline,
} from 'react-google-login'
import { useDispatch, useSelector } from 'react-redux'
import { setGoogleToken } from '../../store/actions'
import { State } from '../../store/types'
import { LocalStorage } from '../../utils/localStorage'
import style from './GoogleLogin.module.css'
import axios from 'axios'

export default function GoogleLogin({
  onLogin,
}: {
  onLogin: (res?: GoogleLoginResponse) => void
}) {
  const googleToken = useSelector<State, string | null>(
    (state: State) => state.app.googleToken,
  )

  const dispatch = useDispatch()

  useEffect(() => {
    if (googleToken) {
      onLogin()
    }

    return () => {}
  }, [googleToken, onLogin])

  const handleSuccess = ({ tokenId }: GoogleLoginResponse) => {
    axios.defaults.headers.common = { Authorization: `Bearer ${tokenId}` }

    dispatch(setGoogleToken(tokenId))
    LocalStorage.setGoogleToken(tokenId)
  }

  return (
    <div className={style.root}>
      {/* @ts-ignore */}
      <ReactGoogleLogin
        clientId="729722268284-resvfi19ib6v2su32v4qk0958gt023ia.apps.googleusercontent.com"
        buttonText="Login"
        isSignedIn
        render={(renderProps) => (
          <button
            onClick={renderProps.onClick}
            disabled={renderProps.disabled}
            className={style.button}
          >
            Login with Google
          </button>
        )}
        onSuccess={(
          response: GoogleLoginResponse | GoogleLoginResponseOffline,
        ) => {
          handleSuccess(response as GoogleLoginResponse)
          onLogin(response as GoogleLoginResponse)
        }}
        onFailure={() => {
          console.log('failure')
        }}
        cookiePolicy={'single_host_origin'}
      />
      ,
    </div>
  )
}
